// extracted by mini-css-extract-plugin
export default {"layout":"Activity_layout__+eprl","mainWrapper":"Activity_mainWrapper__ZLakF","TopNavWrapper":"Activity_TopNavWrapper__e3ak2","bodyWrapper":"Activity_bodyWrapper__aFttP"};